<template>
  <div
    class="layout-card"
    :class="{ 'layout-card--selected': isSelected }"
    @click="$emit('select', id)"
  >
    <div class="flex items-center gap-2 mb-3">
      <input
        :checked="isSelected"
        :id="id"
        type="radio"
        value=""
        name="layout-radio"
        class="radio-primary"
        @click.stop
        @change="$emit('select', id)"
      />
      <label
        :for="id"
        class="text-sm font-medium text-primary-dark cursor-pointer"
      >
        {{ label }}
      </label>
    </div>

    <div class="flex justify-center py-3">
      <slot name="icon" />
    </div>

    <div v-if="$slots.extra" class="mt-2">
      <slot name="extra" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LayoutCard",
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["select"],
});
</script>

<style scoped>
.layout-card {
  @apply flex flex-col rounded-lg border border-neutral-25 bg-white p-4 cursor-pointer
    transition-all duration-200 ease-in-out hover:border-neutral-50 hover:shadow-sm;
}

.layout-card--selected {
  @apply border-2 border-primary-main shadow-sm;
}
</style>
